import { render } from "./EventView.vue?vue&type=template&id=63990eda"
import script from "./EventView.vue?vue&type=script&lang=js"
export * from "./EventView.vue?vue&type=script&lang=js"

import "./EventView.vue?vue&type=style&index=0&id=63990eda&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__